export default __webpack_public_path__ + "static/media/SecondaryUser.8e3b5184.svg";